import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { OpenPositionDetailView } from "@/views/open-position-detail/open-position-detail.view";
import { Route, Switch } from "wouter";
import { OpenPositionView } from "./open-position.view";

export function OpenPositionRoutes() {
  const openPositionDetailUuidRegex = generateUuidV4Regex({ paramName: "uuid" });

  return (
    <Switch>
      <Route path="/" component={OpenPositionView} />
      <Route path={openPositionDetailUuidRegex} component={OpenPositionDetailView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
